import { z } from "zod";
import { directoryRoleSchema } from "@/shared/membership/directory.schema";

export const changeMemberRoleInputSchema = z
  .object({
    role: directoryRoleSchema,
  })
  .strict();
export type ChangeMemberRoleInput = z.infer<typeof changeMemberRoleInputSchema>;

export const changeMemberRoleResponseSchema = z.object({
  id: z.string(),
  role: directoryRoleSchema,
});
export type ChangeMemberRoleResponse = z.infer<typeof changeMemberRoleResponseSchema>;
